<template>
  <div>
    <HeaderCard />
    <v-container class="pa-3 pt-6 pb-0">
        <v-card v-if="nextpointTo && shopId !== 'Ub067d158c52aaaec79b67cfc997fda79'" elevation="2" class="pt-7 pb-7 pl-4 pr-4 mb-5">
            <v-card-text>
                <v-row>
                    <v-col class="text-start font18 headline1 bold"> {{ $t("message.collectMore") }} {{formatNumber(nextpointTo)}} {{ $t("message.pointMore") }} {{ $t("message.levelUp") }} {{nextlevel.name}}</v-col>
                    <!-- <v-col class="text-end font18 headline1 bold">{{formatNumber(nextpointTo)}} คะแนน</v-col> -->
                </v-row>
            </v-card-text>
        </v-card>
        <v-row>
          <!-- {{member.priviledgeEng}} -->
            <v-col class="bold">{{ $t("message.privilegeLevel") }} <span class="font18 headline1">{{this.lavelName2}}</span></v-col>
        </v-row>
        <v-row v-if="$i18n.locale === 'th' || member.priviledgeEng === '' || member.priviledgeEng === null">
            <v-col><nl2br v-if="member.priviledge" tag="p" :text="member.priviledge" /></v-col>
        </v-row>
        <v-row v-if="$i18n.locale === 'en' && member.priviledgeEng !== null">
            <v-col><nl2br v-if="member.priviledgeEng" tag="p" :text="member.priviledgeEng" /></v-col>
        </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LMGHeaderCard from '../Card/C/HeaderCard.vue'

export default {
  components: {
    LMGHeaderCard
  },
  data () {
    return {
      datacollection: null,
      member: null,
      profile: null,
      level: null,
      nextlevel: null,
      nextpointTo: null,
      lavelName2: '',
      options: {
        plugins: {
          doughnutlabel: {
            labels: [
              {
                text: this.$t('message.privilegeLevel'),
                color: '#fff'
              }, {
                text: '',
                color: '#fff',
                font: {
                  size: 20,
                  weight: 'bold'
                }
              }]
          }
        },
        tooltips: {callbacks: {
          label: function (tooltipItem, data) {
            var value = data.datasets[0].data[tooltipItem.index]
            value = value.toString()
            value = value.split(/(?=(?:...)*$)/)
            value = value.join(',')
            return value
          }}
        },
        legend: {
          labels: {
            fontColor: 'white',
            usePointStyle: true,
            boxWidth: 10
          }
        }
      }
    }
  },
  async mounted () {
    await this.prepareData()
    if (this.nextlevel) {
      this.fillData()
    } else {
      this.fillData2()
    }
    this.nextpointTo = this.nextlevel.point - this.member.collectPoint
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),

    async prepareData () {
      this.member = this.GET_MEMBERINFO()
      this.profile = this.getLiffProfile()

      this.level = await this.getLevel()
      this.lavelName2 = this.member.levelName
      this.level.sort((a, b) => { return b.point - a.point })
      this.level.map((row) => {
        if (this.member.collectPoint < row.point) {
          this.nextlevel = row
        }
      })
      this.options.plugins.doughnutlabel.labels[1].text = this.lavelName2
    },
    async getLevel () {
      const result = await this.callBeTaskAPI('get', '/level/line/get?RECORD_STATUS=N')
      if (result) {
        if (result.length > 0) {
          // this.setLevel(result)
          this.level = result
          return result
        }
      }
    },
    fillData () {
      let total = this.nextlevel.point - this.member.collectPoint
      // let a = this.formatNumber(total)
      // console.log('a', a)
      // console.log('a2', parseInt(a.replace(/,/g, ''), 10))
      // console.log('a3', a)
      this.$t('message.collectMore')
      this.datacollection = {
        labels: [this.$t('message.youPoint'), this.$t('message.collectMore')],
        datasets: [
          {
            backgroundColor: [this.member.color, '#dddddd'],
            data: [this.member.collectPoint, (this.nextlevel.point - this.member.collectPoint)]
          }
        ]
      }
    },
    fillData2 () {
      this.datacollection = {
        labels: [this.$t('message.youPoint'), this.$t('message.collectMore')],
        datasets: [
          {
            backgroundColor: [this.member.color, '#dddddd'],
            data: [this.member.collectPoint]
          }
        ]
      }
    },
    async getMyReward () {
      const result = await this.callBeTaskAPI(
        'get',
        `/rewardCode/line/get?redeemStatus=get`
      )
      if (Array.isArray(result)) {
        this.rewards = result
      }
    },
    async upDatePDPA () {
      await this.callBeTaskAPI(
        'post',
        `/member/edit/${this.member.memberId}`,
        {CONDITION_TERM1: this.checkTerm1, CONDITION_TERM2: this.checkTerm2}
      )
      this.getMemberProfile()
    },
    async getLevelDB () {
      const result = await this.callBeTaskAPI(
        'get',
        '/level/line/get?RECORD_STATUS=N'
      )
      if (result) {
        if (result.length > 0) {
          this.level = result
          this.allLevel = result
          return result
        }
      }
    }
  }
}
</script>
<style scoped>
.chart_bg {
    background-color: #EDEDED;
}
.myChartDiv {
  width: 250px;
  height: 250px;
}
.v-progress-linear {
  width: 90%;
}
</style>



// WEBPACK FOOTER //
// src/components/Card/Level.vue